import React, { useState, useEffect, useRef } from 'react';
import api, { getPedidosAdmin, atualizarStatus } from '../../services/api';

const STATUS_LABEL = { aguardando:'⏳ Aguardando', aceito:'✅ Aceito', preparo:'🔥 Em preparo', pronto:'🎉 Pronto!', entregando:'🛵 Entregando', entregue:'🏁 Entregue', cancelado:'❌ Cancelado' };
const STATUS_COR = {
  aguardando: { bg:'rgba(255,107,0,.12)', border:'rgba(255,107,0,.5)', color:'var(--orange)' },
  aceito:     { bg:'rgba(74,158,255,.12)', border:'rgba(74,158,255,.5)', color:'#4a9eff' },
  preparo:    { bg:'rgba(230,48,48,.12)', border:'rgba(230,48,48,.5)', color:'var(--red)' },
  pronto:     { bg:'rgba(46,168,46,.12)', border:'rgba(46,168,46,.5)', color:'#2ea82e' },
  entregando: { bg:'rgba(74,158,255,.12)', border:'rgba(74,158,255,.5)', color:'#4a9eff' },
  entregue:   { bg:'rgba(46,168,46,.06)', border:'rgba(46,168,46,.2)', color:'#2ea82e' },
  cancelado:  { bg:'rgba(230,48,48,.06)', border:'rgba(230,48,48,.2)', color:'var(--red)' },
};
const PROXIMOS = {
  aguardando: [{ s:'aceito',     label:'✅ Aceitar',          cor:'#4a9eff' }],
  aceito:     [{ s:'preparo',    label:'🔥 Iniciar preparo',   cor:'var(--orange)' }],
  preparo:    [{ s:'pronto',     label:'🎉 Pronto!',           cor:'#2ea82e' }],
  pronto:     [{ s:'entregando', label:'🛵 Saiu para entrega', cor:'#4a9eff' }],
  entregando: [{ s:'entregue',   label:'🏁 Entregue',          cor:'#2ea82e' }],
};

// ==================== SOM DE NOTIFICAÇÃO ====================
function tocarSomPedido() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const tocar = (freq, start, dur) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.3, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
    };
    tocar(880, 0, 0.15);
    tocar(1100, 0.18, 0.15);
    tocar(1320, 0.36, 0.25);
  } catch {}
}

// ==================== IMPRESSÃO TÉRMICA ====================
function imprimirTermica(p) {
  const w = window.open('', '_blank', 'width=340,height=750');
  const hora = new Date(p.criado_em).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
  const data = new Date(p.criado_em).toLocaleDateString('pt-BR');
  const itens = p.itens_resumo?.split(', ') || [];

  // Separar nome do item das observações
  const itensFormatados = itens.map(item => {
    const partes = item.split(' — obs: ');
    return { nome: partes[0].trim(), obs: partes[1] || null };
  });

  // Verificar forma de pagamento nas observações
  const obsPagamento = p.observacoes?.startsWith('PAGAMENTO:') ? p.observacoes : null;
  const obsGeral = p.observacoes && !p.observacoes.startsWith('PAGAMENTO:') ? p.observacoes : null;

  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Pedido #${p.id}</title>
  <style>
    *{margin:0;padding:0;box-sizing:border-box}
    body{font-family:'Courier New',monospace;font-size:13px;width:80mm;max-width:80mm;padding:4mm;color:#000;background:#fff}
    .c{text-align:center}.b{font-weight:bold}.big{font-size:17px;font-weight:bold}
    .div{border-top:1px dashed #000;margin:5px 0}.divs{border-top:2px solid #000;margin:7px 0}
    .row{display:flex;justify-content:space-between;margin:2px 0}
    .iname{font-weight:bold;font-size:14px;margin-top:5px}
    .iadd{font-size:11px;margin-left:8px;padding:1px 0}
    .irem{font-size:11px;margin-left:8px;padding:1px 0}
    .iobs{font-size:11px;margin-left:8px;padding:1px 0;font-style:italic}
    .total{display:flex;justify-content:space-between;font-size:15px;font-weight:bold;margin:3px 0}
    .box{border:2px solid #000;padding:4px 8px;text-align:center;font-size:15px;font-weight:bold;margin:5px 0}
    .pag{border:1px solid #000;padding:6px 8px;margin:5px 0;font-size:13px}
    .foot{text-align:center;font-size:11px;margin-top:8px}
    @media print{body{width:80mm}@page{size:80mm auto;margin:0}}
  </style></head><body>

  <div class="c">
    <div class="big">LANCHES DO PARQUE</div>
    <div style="font-size:10px">lanchesdoparque.app</div>
  </div>

  <div class="divs"></div>
  <div class="c big">PEDIDO #${p.id}</div>
  <div class="div"></div>

  <div class="row"><span>Data:</span><span>${data} ${hora}</span></div>
  <div class="row"><span>Cliente:</span><span>${p.cliente_nome || 'Cliente'}</span></div>
  ${p.cliente_tel ? `<div class="row"><span>Tel:</span><span>${p.cliente_tel}</span></div>` : ''}

  ${p.endereco_entrega ? `
  <div class="div"></div>
  <div class="b">📍 ENDEREÇO:</div>
  <div style="font-size:12px;margin-top:3px;line-height:1.5">${p.endereco_entrega}</div>` : ''}

  <div class="divs"></div>
  <div class="b c" style="font-size:14px;margin-bottom:5px">═══ ITENS ═══</div>

  ${itensFormatados.map(item => {
    const obs = item.obs || '';
    const partes = obs.split(' | ');
    const adicionar = partes.find(o => o.startsWith('Adicionar:'));
    const retirar = partes.find(o => o.startsWith('Retirar:'));
    const nota = partes.find(o => !o.startsWith('Adicionar:') && !o.startsWith('Retirar:') && o.trim());
    return `
      <div>
        <div class="iname">${item.nome}</div>
        ${adicionar ? `<div class="iadd">➕ ${adicionar}</div>` : ''}
        ${retirar ? `<div class="irem">➖ ${retirar}</div>` : ''}
        ${nota ? `<div class="iobs">💬 ${nota}</div>` : ''}
      </div>
      <div class="div"></div>
    `;
  }).join('')}

  <div class="row"><span>Subtotal:</span><span>R$ ${parseFloat(p.subtotal||0).toFixed(2).replace('.',',')}</span></div>
  <div class="row"><span>Taxa entrega:</span><span>R$ ${parseFloat(p.taxa_entrega||3).toFixed(2).replace('.',',')}</span></div>
  ${parseFloat(p.desconto||0)>0 ? `<div class="row"><span>Desconto:</span><span>- R$ ${parseFloat(p.desconto).toFixed(2).replace('.',',')}</span></div>` : ''}
  <div class="div"></div>
  <div class="total"><span>TOTAL:</span><span>R$ ${parseFloat(p.total||0).toFixed(2).replace('.',',')}</span></div>
  <div class="div"></div>

  <div class="pag">
    ${obsPagamento ? `<div class="b">${obsPagamento.replace('PAGAMENTO: ', '💳 PAGAMENTO: ')}</div>` : '<div class="b">💳 PAGAMENTO: PIX ✅</div>'}
  </div>

  ${obsGeral ? `
  <div class="div"></div>
  <div class="b">⚠️ OBS GERAL:</div>
  <div style="font-size:12px;margin-top:3px">${obsGeral}</div>` : ''}

  <div class="divs"></div>
  <div class="box">🔥 PREPARAR AGORA</div>
  <div class="foot"><div>Empório Paco</div><div>Obrigado! 🍔</div></div>
  <script>window.onload=function(){window.print()}</script>
  </body></html>`);
  w.document.close();
}

// ==================== COMPONENTE PRINCIPAL ====================
export default function AdminPedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('ativos');
  const [somAtivo, setSomAtivo] = useState(true);
  const [novoPedido, setNovoPedido] = useState(false);
  const interval = useRef();
  const idsConhecidos = useRef(new Set());

  const carregar = async () => {
    try {
      const r = await getPedidosAdmin();
      const novos = r.data;

      // Verificar novos pedidos para tocar som
      if (idsConhecidos.current.size > 0) {
        const novosIds = novos.map(p => p.id);
        const chegaram = novosIds.filter(id => !idsConhecidos.current.has(id));
        if (chegaram.length > 0 && somAtivo) {
          tocarSomPedido();
          setNovoPedido(true);
          setTimeout(() => setNovoPedido(false), 3000);
        }
      }
      novos.forEach(p => idsConhecidos.current.add(p.id));
      setPedidos(novos);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => {
    carregar();
    interval.current = setInterval(carregar, 20000);
    return () => clearInterval(interval.current);
  }, [somAtivo]);

  const mudar = async (id, status) => { await atualizarStatus(id, status); carregar(); };

  // === ENTREGADORES ===
  const [entregadores, setEntregadores] = React.useState([]);
  const [modalEntregador, setModalEntregador] = React.useState(null);
  const [selecEntregador, setSelecEntregador] = React.useState('');
  const [selecTaxa, setSelecTaxa] = React.useState('');

  React.useEffect(() => {
    api.get('/entregas/entregadores').then(r => setEntregadores(r.data)).catch(() => {});
  }, []);

  const abrirModalEntregador = (p) => {
    setModalEntregador(p);
    setSelecEntregador(p.entregador_id || '');
    setSelecTaxa(p.taxa_entregador || '');
  };

  const salvarEntregador = async () => {
    if (!selecEntregador) return alert('Selecione um entregador');
    try {
      await api.post(`/entregas/pedido/${modalEntregador.id}`, {
        entregador_id: parseInt(selecEntregador),
        taxa_entregador: parseFloat(selecTaxa) || 0
      });
      setModalEntregador(null);
      carregar();
    } catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  const removerEntregador = async () => {
    if (!window.confirm('Remover entregador deste pedido?')) return;
    try {
      await api.delete(`/entregas/pedido/${modalEntregador.id}`);
      setModalEntregador(null);
      carregar();
    } catch { alert('Erro'); }
  };

  const preencherTaxaPadrao = () => {
    const ent = entregadores.find(e => e.id === parseInt(selecEntregador));
    if (ent && ent.taxa_entrega_padrao > 0) {
      setSelecTaxa(parseFloat(ent.taxa_entrega_padrao).toFixed(2));
    }
  };

  const filtrados = pedidos.filter(p =>
    filtro === 'ativos'     ? !['entregue','cancelado'].includes(p.status) :
    filtro === 'entregues'  ? p.status === 'entregue' :
    filtro === 'cancelados' ? p.status === 'cancelado' : true
  );

  const countAtivos = pedidos.filter(p => !['entregue','cancelado'].includes(p.status)).length;

  return (
    <div style={{ padding: 24 }}>
      {/* Alerta novo pedido */}
      {novoPedido && (
        <div style={{ position: 'fixed', top: 70, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '12px 24px', borderRadius: 20, fontSize: 14, fontWeight: 800, zIndex: 999, boxShadow: '0 4px 20px rgba(230,48,48,.5)', animation: 'pulse 0.5s ease' }}>
          🔔 NOVO PEDIDO CHEGOU!
        </div>
      )}

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:12 }}>
        <div>
          <h2 style={{ margin:0 }}>📦 Pedidos</h2>
          <p style={{ color:'var(--text2)', fontSize:13, marginTop:4 }}>Atualiza a cada 20 segundos</p>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          {/* Toggle som */}
          <button onClick={() => setSomAtivo(p => !p)} style={{ background: somAtivo ? 'rgba(46,168,46,.15)' : 'var(--bg4)', border: `1px solid ${somAtivo ? '#2ea82e' : 'var(--border)'}`, color: somAtivo ? '#2ea82e' : 'var(--text2)', padding:'8px 14px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>
            {somAtivo ? '🔔 Som ON' : '🔕 Som OFF'}
          </button>
          <button onClick={carregar} style={{ background:'var(--bg4)', border:'1px solid var(--border)', color:'var(--text)', padding:'8px 16px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>🔄 Atualizar</button>
        </div>
      </div>

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {[['ativos',`🔥 Ativos (${countAtivos})`],['entregues','✅ Entregues'],['cancelados','❌ Cancelados'],['todos','📋 Todos']].map(([key,label]) => (
          <button key={key} onClick={() => setFiltro(key)} style={{
            background: filtro===key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'var(--bg3)',
            border: `1px solid ${filtro===key ? 'transparent' : 'var(--border)'}`,
            color: filtro===key ? '#fff' : 'var(--text2)',
            padding:'8px 18px', borderRadius:20, cursor:'pointer', fontSize:13,
            fontFamily:'Nunito,sans-serif', fontWeight:700
          }}>{label}</button>
        ))}
      </div>

      {loading ? <div className="spinner" /> : !filtrados.length ? (
        <div className="empty-state"><div className="icon">📦</div><h3>Nenhum pedido</h3><p>Os pedidos aparecem aqui em tempo real</p></div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(380px, 1fr))', gap:16 }}>
          {filtrados.map(p => {
            const cor = STATUS_COR[p.status] || STATUS_COR.aguardando;
            const hora = new Date(p.criado_em).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
            const data = new Date(p.criado_em).toLocaleDateString('pt-BR');
            const itens = p.itens_resumo?.split(', ') || [];
            const obsPagamento = p.observacoes?.startsWith('PAGAMENTO:') ? p.observacoes : null;
            const obsGeral = p.observacoes && !p.observacoes.startsWith('PAGAMENTO:') ? p.observacoes : null;

            return (
              <div key={p.id} style={{ background:'var(--bg2)', border:`2px solid ${cor.border}`, borderRadius:14, overflow:'hidden' }}>

                {/* Header */}
                <div style={{ background:cor.bg, padding:'12px 16px', borderBottom:`1px solid ${cor.border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <span style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:22, color:cor.color }}>PEDIDO #{p.id}</span>
                    <div style={{ fontSize:12, color:'var(--text2)', marginTop:2 }}>📅 {data} às {hora}</div>
                  </div>
                  <span style={{ background:cor.bg, border:`1px solid ${cor.border}`, color:cor.color, padding:'5px 12px', borderRadius:20, fontSize:12, fontWeight:700 }}>
                    {STATUS_LABEL[p.status]}
                  </span>
                </div>

                {/* Cliente */}
                <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ width:36, height:36, borderRadius:'50%', background:'linear-gradient(135deg,var(--red),var(--orange))', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:14, color:'#fff', flexShrink:0 }}>
                      {(p.cliente_nome||'C')[0].toUpperCase()}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, fontSize:14 }}>{p.cliente_nome||'Cliente'}</div>
                      {p.cliente_tel && <div style={{ fontSize:12, color:'var(--text2)' }}>📱 {p.cliente_tel}</div>}
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize:18, fontWeight:800, color:'var(--orange)' }}>R$ {parseFloat(p.total).toFixed(2).replace('.',',')}</div>
                      <div style={{ fontSize:11, color: obsPagamento?.includes('Dinheiro') ? 'var(--orange)' : (p.pix_pago ? '#2ea82e' : '#e6a23c'), fontWeight: 700 }}>
                        {obsPagamento?.includes('Dinheiro') ? '💵 Dinheiro' : (p.pix_pago ? '✅ PIX pago' : '⏳ PIX aguardando')}
                      </div>
                    </div>
                  </div>
                  {p.endereco_entrega && (
                    <div style={{ marginTop:8, background:'rgba(255,107,0,.08)', border:'1px solid rgba(255,107,0,.2)', borderRadius:6, padding:'6px 10px', fontSize:12, color:'var(--text2)' }}>
                      📍 {p.endereco_entrega}
                    </div>
                  )}
                  {obsPagamento && (
                    <div style={{ marginTop:6, background:'rgba(74,158,255,.08)', border:'1px solid rgba(74,158,255,.2)', borderRadius:6, padding:'6px 10px', fontSize:12, color:'#4a9eff' }}>
                      💳 {obsPagamento.replace('PAGAMENTO: ', '')}
                    </div>
                  )}
                </div>

                {/* Itens */}
                <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)' }}>
                  <div style={{ fontSize:11, fontWeight:800, color:'var(--text2)', marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>Itens do pedido</div>
                  {itens.map((item, i) => {
                    const partes = item.split(' — obs: ');
                    const nome = partes[0];
                    const obs = partes[1];
                    const obsPartes = obs ? obs.split(' | ') : [];
                    return (
                      <div key={i} style={{ padding:'5px 0', borderBottom: i < itens.length-1 ? '1px solid var(--border)' : 'none' }}>
                        <div style={{ fontSize:13, fontWeight:700 }}>{nome}</div>
                        {obsPartes.map((o, j) => (
                          <div key={j} style={{ fontSize:11, marginTop:2,
                            color: o.startsWith('Adicionar') ? '#2ea82e' : o.startsWith('Retirar') ? 'var(--red)' : 'var(--orange)'
                          }}>
                            {o.startsWith('Adicionar') ? '➕' : o.startsWith('Retirar') ? '➖' : '💬'} {o}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                  {obsGeral && (
                    <div style={{ marginTop:8, background:'rgba(255,107,0,.1)', border:'1px solid rgba(255,107,0,.3)', borderRadius:6, padding:'6px 10px', fontSize:12, color:'var(--orange)' }}>
                      ⚠️ <strong>Obs:</strong> {obsGeral}
                    </div>
                  )}
                  {parseFloat(p.desconto||0) > 0 && (
                    <div style={{ marginTop:6, fontSize:12, color:'#2ea82e' }}>🎟️ Desconto: R$ {parseFloat(p.desconto).toFixed(2).replace('.',',')}</div>
                  )}
                </div>

                {/* Botões */}
                <div style={{ padding:'12px 16px' }}>
                  <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:8 }}>
                    {(PROXIMOS[p.status]||[]).map(({ s, label, cor:c }) => (
                      <button key={s} onClick={() => mudar(p.id, s)} style={{
                        flex:1, background:`${c}22`, border:`1px solid ${c}`, color:c,
                        padding:'10px 14px', borderRadius:8, cursor:'pointer', fontSize:13,
                        fontFamily:'Nunito,sans-serif', fontWeight:800, minWidth:140
                      }}
                        onMouseOver={e => { e.currentTarget.style.background=c; e.currentTarget.style.color='#fff'; }}
                        onMouseOut={e => { e.currentTarget.style.background=`${c}22`; e.currentTarget.style.color=c; }}
                      >{label}</button>
                    ))}
                  </div>
                  <div style={{ display:'flex', gap:8 }}>
                    <button onClick={() => imprimirTermica(p)} style={{ flex:1, background:'var(--bg3)', border:'1px solid var(--border)', color:'var(--text)', padding:'9px 14px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>
                      🖨️ Imprimir
                    </button>
                    {!['cancelado'].includes(p.status) && (
                      <button onClick={() => abrirModalEntregador(p)} style={{ flex:1, background: p.entregador_id ? 'rgba(74,158,255,.15)' : 'var(--bg3)', border:`1px solid ${p.entregador_id ? '#4a9eff' : 'var(--border)'}`, color: p.entregador_id ? '#4a9eff' : 'var(--text)', padding:'9px 14px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>
                        🛵 {p.entregador_id ? 'Entregador ✓' : 'Entregador'}
                      </button>
                    )}
                    {!['entregue','cancelado'].includes(p.status) && (
                      <button onClick={() => mudar(p.id, 'cancelado')} style={{ background:'rgba(230,48,48,.1)', border:'1px solid rgba(230,48,48,.3)', color:'var(--red)', padding:'9px 14px', borderRadius:8, cursor:'pointer', fontSize:13, fontFamily:'Nunito,sans-serif', fontWeight:700 }}>❌</button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {/* Modal Entregador */}
      {modalEntregador && (
        <div onClick={() => setModalEntregador(null)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, zIndex:1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'var(--bg2, #1a1a1a)', borderRadius:12, padding:20, maxWidth:420, width:'100%', border:'1px solid var(--border)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
              <h3 style={{ fontSize:16, fontWeight:800 }}>🛵 Entregador - Pedido #{modalEntregador.id}</h3>
              <button onClick={() => setModalEntregador(null)} style={{ background:'none', border:'none', color:'#fff', fontSize:22, cursor:'pointer' }}>×</button>
            </div>

            <label style={{ fontSize:12, color:'var(--text2)', display:'block', marginBottom:4 }}>Entregador</label>
            <select value={selecEntregador} onChange={e => { setSelecEntregador(e.target.value); setTimeout(preencherTaxaPadrao, 50); }} style={{ width:'100%', padding:10, background:'var(--bg4, #222)', border:'1px solid var(--border)', color:'var(--text)', borderRadius:6, fontSize:14, marginBottom:12 }}>
              <option value="">-- Selecione --</option>
              {entregadores.map(e => (
                <option key={e.id} value={e.id}>
                  {e.nome} {e.taxa_entrega_padrao > 0 ? `(padrão R$ ${parseFloat(e.taxa_entrega_padrao).toFixed(2)})` : ''}
                </option>
              ))}
            </select>

            <label style={{ fontSize:12, color:'var(--text2)', display:'block', marginBottom:4 }}>Taxa a pagar (R$)</label>
            <input type="number" step="0.01" value={selecTaxa} onChange={e => setSelecTaxa(e.target.value)} placeholder="0,00" style={{ width:'100%', padding:10, background:'var(--bg4, #222)', border:'1px solid var(--border)', color:'var(--text)', borderRadius:6, fontSize:16, fontWeight:700, marginBottom:16 }} />

            <div style={{ display:'flex', gap:8 }}>
              {modalEntregador.entregador_id && (
                <button onClick={removerEntregador} style={{ padding:'10px 14px', background:'rgba(230,48,48,.15)', border:'1px solid rgba(230,48,48,.4)', color:'#ff6b7a', borderRadius:6, cursor:'pointer', fontSize:13, fontWeight:600 }}>🗑️ Remover</button>
              )}
              <button onClick={() => setModalEntregador(null)} style={{ flex:1, padding:'10px 14px', background:'var(--bg3)', border:'none', color:'#fff', borderRadius:6, cursor:'pointer', fontSize:13 }}>Cancelar</button>
              <button onClick={salvarEntregador} style={{ flex:1, padding:'10px 14px', background:'linear-gradient(90deg,#e63946,#FF6B00)', border:'none', color:'#fff', borderRadius:6, cursor:'pointer', fontSize:13, fontWeight:700 }}>💾 Salvar</button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes pulse{0%{transform:translateX(-50%) scale(0.8)}100%{transform:translateX(-50%) scale(1)}}`}</style>
    </div>
  );
}
